import { useEffect, useRef } from 'react';

import { useCookiebotConsent } from 'app/shared/utils/useCookiebotConsent';

import { AnalyticsContextValues } from './index';

// Sends the visitor's Cookiebot answer to Segment once per page load, and again whenever they
// change it. It's skipped until Segment has loaded (trackAnalyticsEvent is undefined until then).
export const useTrackConsentPreferenceUpdated = (
  trackAnalyticsEvent?: AnalyticsContextValues['trackAnalyticsEvent']
) => {
  const cookieConsent = useCookiebotConsent();
  const trackedConsentStampRef = useRef<string | null>(null); // The answer last sent to Segment

  useEffect(() => {
    const consent = window.Cookiebot?.consent;

    if (
      trackAnalyticsEvent &&
      cookieConsent.consentReady &&
      consent &&
      consent.stamp !== trackedConsentStampRef.current
    ) {
      trackedConsentStampRef.current = consent.stamp;
      trackAnalyticsEvent('Segment Consent Preference Updated', {
        stamp: consent.stamp,
        consent_method: consent.method,
        necessary: consent.necessary,
        preferences: consent.preferences,
        statistics: consent.statistics,
        marketing: consent.marketing,
      });
    }
  }, [trackAnalyticsEvent, cookieConsent]);
};
